// @flow
import React from 'react'
import Link from "gatsby-link"
import injectSheet from "react-jss"
import classNames from 'classnames'

import {styles} from './Styles/TextImageSection.Style'

import WorkingSpace from '../images/Working-space.jpg'
import Shopify from '../images/Shopify-logo.png'
import Shopify2x from '../images/Shopify-logo@2x.png'

type Props = {
  classes: { [string]: string }
}

class TextImageSection extends React.Component {
  props: Props

    render () {
      const {classes} = this.props

      return (
        <div className={classes.conatainer}>
          <div className='container wrap'>
            <div className='row'>
              <img
                src={WorkingSpace}
                alt='Working Space'
                className={classNames(
                  classes.workingSpaceImg,
                  classes.xsHide,
                  'col-md-8 col-md-offset-4 col-sm-11 col-sm-offset-1 col-xs-12')} />
              <div
                className={classNames(
                  classes.section,
                  classes.padding,
                  'col-sm-offset-0 col-sm-6 col-xs-offset-1 col-xs-10')}>
                <h2>
                  Partsee works with the tools you use. It adapts to your
                  workflow.
                </h2>
                <p>
                  Partsee integrates with Shopify to keep your collection
                  in sync on all platforms. Avoid the hassle of keeping all your
                  products' information up to date by hand. <br />
                  Update a product in Partsee, sync it everywhere.<br /><br />
                </p>
                <img
                  src={Shopify}
                  srcSet={Shopify2x}
                  alt='Shopify'
                  width= '194' />
                <p className={'textSmall'}>More integrations are coming soon. <a href="#" className={'drift-open-chat'}>Chat with us to learn more</a></p>
              </div>
            </div>
          </div>
        </div>
      )
    }
}

export default injectSheet(styles)(TextImageSection)



// WEBPACK FOOTER //
// ./src/layouts/TextImageSection.jsx